import React from "react";
// 外線番号共通ユーティリティ（純粋関数）
import { evaluateExternalNumbers, detectInvalidExternalNumbers, extractExternalValues, buildCallTextDownloadFilenameFromPlaybackState } from "../../components/AscUtils";
import { CALL_TEXT_DOWNLOAD } from "../../config/constants";
import {Button, Row, Col} from "react-bootstrap";
import Component from "../../components/AscComponent";
import CommonTable from "../Elements/Table/CommonTable";
import PhoneBookDeleteModal from "./PhoneBookDeleteModal";
import PhoneBookInsertModal from "./PhoneBookInsertModal";
import PhoneBookUpdateModal from "./PhoneBookUpdateModal";
import PhoneBookReadModal from "./PhoneBookReadModal";
import PhoneBookUnifyModal from "./PhoneBookUnifyModal";
import RecordPlaybackModal from "../Record/RecordPlaybackModal";
import PhoneBookImportModal from "./PhoneBookImportModal";
import PhoneBookExportModal from "./PhoneBookExportModal";
import moment from "moment";

export default class PhoneBook extends Component {
    constructor(props) {
        super(props);

        // テーブルのrefを作成
        this.tableRef = React.createRef();

        this.state = {
            // テーブル項目
            columns: [],
            data: [],
            pages: null,
            pageCount: 0,
            pageSize: 20,
            pageIndex: 0,
            loading: false,
            filtered: [],
            sorted: [{id: "id", desc: true}],

            // モーダル項目
            show: false,
            modalType: null,
            selectedData: [],

            // フォームデータ
            id: 0,
            name: "",
            phone_number: "",
            memo: "",
            last_call: "",
            category: "",
            call_histories_total_count: "",
            external_number: [],
            external_number_val: [],
            external_number_invalids: [], // 外線番号バリデーション結果（不正値）
            
            // 重複チェック用データ
            duplicate_phonebook_external_number: "",
            duplicate_phonebook_external_numbers: [], // 複数の重複番号を保存
            company_name: "",
            existing_external_number: [],
            existing_phonebook_id: null, // 既存要約詳細のID保存
            duplicate_data_list: [], // 全重複データを保存
            
            // 元のモーダル状態を保存
            previous_modal_type: null,
            
            // ★追加: 音声再生用ステート (#142)
            playback_url: "", // S3 presigned URL
            playback_external_number: "", // 外線番号(再生用)
            playback_dest_tel_number: "", // 着信番号(再生用)
            playback_inout_type: "", // 発着信タイプ(再生用)
            playback_answer_datetime: "", // 通話日時(再生用)
            playback_ht87_voice_log_to_text: "", // 文字起こしデータ
            playback_ht88_categories: "", // カテゴリ
            playback_ht88_analysis_data: "", // 解析データ
            playback_s3_object_key: "", // S3オブジェクトキー
            playback_customer_id: "", // 顧客ID
            playback_customer_name: "", // 顧客名
            playback_memo: "", // 録音に紐づくメモ(再生用)
            
            // ★追加: ダブルモーダル用ステート (summary モーダルの上に playback モーダルを重ねる)
            playbackModal: false, // 音声再生モーダルの表示状態
            
            // ★追加: 削除フラグの永続化用 (#142)
            // { awt012_id: { answer_datetime_dest_tel_number_inout_type: { voice_del_flag, voice_deleted, voice_deleted_user_id } } }
            deletedVoiceFlags: {},
            // 【#607】一覧で全桁を表示中の電話番号（キーは「連絡先 id_番号の並び順」）
            expandedTelNumbers: {},
            
            // ★追加: 通話履歴読み込み状態 (#200)
            loadingCallHistories: false
        };
    }

    componentDidMount() {
        // propsが利用可能になった後にカラムデータを設定
        this.setState({
            columns: this.getColumnsData()
        });
        
        // テーブルデータ取得用のターゲットを設定
        this.reactTableTarget = "PhoneBook/board";
    }

    /**
     * 日付を「〇〇前」形式に変換する
     */
    getTimeAgo = (dateTime) => {
        const now = moment();

        // 入力を安全にローカル時刻として解釈する
        // 例: "Mon, 22 Sep 2025 12:42:45 GMT" は "GMT" をリテラルとして無視し、壁時計の時刻をそのままローカルとして扱う
        let targetDate = null;
        if (typeof dateTime === 'string') {
            const input = dateTime.trim();
            // RFC1123 形式 + "GMT" リテラル（英語ロケールで厳密パース）
            const rfcLike = moment(input, 'ddd, DD MMM YYYY HH:mm:ss [GMT]', 'en', true);
            if (rfcLike.isValid()) {
                // 同一の年月日時分秒をローカルタイムとして再構築
                targetDate = moment({
                    year: rfcLike.year(),
                    month: rfcLike.month(),
                    date: rfcLike.date(),
                    hour: rfcLike.hour(),
                    minute: rfcLike.minute(),
                    second: rfcLike.second(),
                    millisecond: rfcLike.millisecond()
                });
            } else {
                // 末尾の "GMT" を除去して英語ロケールで再試行
                const stripped = input.replace(/\s*GMT$/i, '');
                const rfcNoTz = moment(stripped, 'ddd, DD MMM YYYY HH:mm:ss', 'en', true);
                const ymdHMS = rfcNoTz.isValid() ? rfcNoTz : moment(input, 'YYYY/MM/DD HH:mm:ss', true);
                if (ymdHMS.isValid()) {
                    targetDate = ymdHMS;
                } else {
                    // フォールバック（可能ならローカル解釈）
                    targetDate = moment(input);
                }
            }
        } else {
            targetDate = moment(dateTime);
        }

        if (!targetDate || !targetDate.isValid()) {
            return "---";
        }

        // 未来時刻は "0分前" として扱う（サーバ・クライアントのタイムゾーン齟齬対策）
        const isFuture = targetDate.isAfter(now);
        if (isFuture) {
            return `0${this.props.langText.Body.Minute}${this.props.langText.Body.Ago}`;
        }
        const baseNow = now;
        const baseTarget = targetDate;

        const diffMinutes = baseNow.diff(baseTarget, 'minutes');
        const diffHours = baseNow.diff(baseTarget, 'hours');
        const diffDays = baseNow.diff(baseTarget, 'days');
        const diffWeeks = Math.floor(diffDays / 7);
        const diffMonths = baseNow.diff(baseTarget, 'months');
        const diffYears = baseNow.diff(baseTarget, 'years');

        if (diffMinutes < 60) {
            return `${diffMinutes}${this.props.langText.Body.Minute}${this.props.langText.Body.Ago}`;
        } else if (diffHours < 24) {
            return `${diffHours}${this.props.langText.Body.Hour}${this.props.langText.Body.Ago}`;
        } else if (diffDays < 7) {
            return `${diffDays}${this.props.langText.Body.Day}${this.props.langText.Body.Ago}`;
        } else if (diffWeeks < 4) {
            return `${diffWeeks}${this.props.langText.Body.Week}${this.props.langText.Body.Ago}`;
        } else if (diffMonths === 0 && diffWeeks >= 4) {
            return `${diffWeeks}${this.props.langText.Body.Week}${this.props.langText.Body.Ago}`;
        } else if (diffMonths < 12) {
            return `${diffMonths}${this.props.langText.Body.Month}${this.props.langText.Body.Ago}`;
        } else {
            return `${diffYears}${this.props.langText.Body.Year}${this.props.langText.Body.Ago}`;
        }
    }

    /**
     * 一覧表作成
     */
    getColumnsData = () => {
        return [
            {
                Header: this.props.langText.Body.Name,
                accessor: "name",
                disableFilters: false,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "name")}
                    />
            }, {
                Header: this.props.langText.Body.Telno,
                id: "dest_tel_number",
                accessor: "awt010_dest_tel_number",
                disableFilters: false,
                Cell: data => {
                    let elemArr = [];
                    data.row.original.awt010_dest_tel_number.forEach((row, key) => {
                        // 【#607】最大 128 桁の番号が列からはみ出さないよう 1 行で「…」に省略し、
                        // 押すと全桁を表示する（もう一度押すと戻す）。マウスを乗せると全桁をツールチップで出す
                        const telKey = `${data.row.original.id}_${key}`;
                        const isExpanded = !!this.state.expandedTelNumbers[telKey];
                        elemArr.push(
                            <p
                                key={key}
                                className={`phonebook-list-tel-number${isExpanded ? " is-expanded" : ""}`}
                                title={row.dest_tel_number}
                                onClick={e => {
                                    e.stopPropagation();
                                    this.setState(prev => ({
                                        expandedTelNumbers: {...prev.expandedTelNumbers, [telKey]: !isExpanded}
                                    }));
                                }}
                            >
                                {row.dest_tel_number}
                            </p>
                        );
                    });
                    return (elemArr);
                },
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "phone_number")}
                    />
            }, {
                Header: this.props.langText.Body.Memo,
                accessor: "memo",
                disableFilters: true
            }, {
                Header: this.props.langText.Body.LastCall,
                disableFilters: true,
                Cell: data => {
                    if (data.row.original.latest_call_history && data.row.original.latest_call_history.answer_datetime) {
                        let elemArr = [];
                        let latest_call_history = data.row.original.latest_call_history;
                        const rawAnswerDatetime = latest_call_history.answer_datetime;
                        const answerMoment = moment(rawAnswerDatetime);

                        // 日時の妥当性チェック
                        if (!answerMoment.isValid()) {
                            return "---";
                        }

                        // 入力のタイムゾーン情報を尊重して表示（parseZoneでゾーン固定）
                        elemArr.push(
                            <p key={"latest_call_date"} className="call-history-date">
                                {moment.parseZone(rawAnswerDatetime).format("YYYY/MM/DD")}
                            </p>
                        );
                        elemArr.push(
                            <p key={"latest_call_time"} className="call-history-date">
                                {moment.parseZone(rawAnswerDatetime).format("HH:mm:ss")}
                            </p>
                        );
                        elemArr.push(
                            <p key={"latest_call_time_ago"} className="call-history-date">
                                {`(${this.getTimeAgo(rawAnswerDatetime)})`}
                            </p>
                        );

                        // カテゴリ情報も確認してから表示
                        if (latest_call_history.categories && latest_call_history.categories.name) {
                            elemArr.push( 
                                <span
                                    key={"latest_call_category"}
                                    style={{
                                        backgroundColor: latest_call_history.categories.rgb,
                                        padding: '2px 4px',
                                        borderRadius: '4px',
                                        color: latest_call_history.categories.font_rgb,
                                        marginRight: '5px',
                                        marginTop: '4px',
                                        marginBottom: '4px',
                                        display: 'inline-block'
                                    }}
                                >
                                    {latest_call_history.categories.name}
                                </span>
                            );
                        }
                        return (elemArr);
                    } else {
                        return "---";
                    }
                }
            }, {
                Header: this.props.langText.Body.CallCategory,
                disableFilters: true,
                Cell: data => {
                    if (data.row.original.categories_count && Array.isArray(data.row.original.categories_count) && data.row.original.categories_count.length > 0) {
                        let elemArr = [];
                        data.row.original.categories_count.forEach((row, key) => {
                            elemArr.push( 
                                <Col key={key} style={{ marginBottom: '4px' }}>
                                    <span
                                        style={{
                                            backgroundColor: row.rgb,
                                            padding: '2px 4px',
                                            borderRadius: '4px',
                                            color: row.font_rgb,
                                            marginRight: '8px',
                                            marginTop: '2px',
                                            marginBottom: '2px',
                                            display: 'inline-block'
                                        }}
                                    >
                                        {row.name}
                                    </span>
                                    <span>
                                        {`${row.count}${this.props.langText.Body.Times}`}
                                    </span>
                                </Col>
                            );
                        });
                        return (elemArr);
                    } else {
                        return "---";
                    }
                }
            }, {
                Header: this.props.langText.Body.TotalCallCnt,
                accessor: "call_histories_total_count",
                disableFilters: true,
                Cell: data => {
                    if (data.row.original.call_histories_total_count) {
                        return `${data.row.original.call_histories_total_count}${this.props.langText.Body.Count}`;
                    } else {
                        return "---";
                    }
                }
            }
        ]
    }

    /**
     * CSVインポート完了時のコールバック
     */
    onImportComplete = async () => {
        // テーブルデータを再読み込み
        this.reactTableRefresh(true);
        // 選択状態をクリア
        this.setState({ selectedData: [] });
    }

    /**
     * モーダル表示分岐
     * ★修正: playbackModal が開いている時は表示しない (#142)
     */
    getModalBranch() {
        // 再生モーダルが開いている時は背景モーダルを非表示
        if (this.state.playbackModal) {
            return null;
        }
        
        switch (this.state.modalType) {
            case "insert":
                return (
                    <PhoneBookInsertModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        onFileChange={this.onFileChange}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onMultiSelectChange_External = {this.onMultiSelectChange_External}
                    />
                );
            case "update":
                return (
                    <PhoneBookUpdateModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        onFileChange={this.onFileChange}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onMultiSelectChange_External = {this.onMultiSelectChange_External}
                        getTimeAgo = {this.getTimeAgo}
                        onPlayAudio = {this.onPlayAudio} // ★追加: 音声再生ハンドラー (#142)
                    />
                );
            case "delete":
                return (
                    <PhoneBookDeleteModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                    />
                );
            case "read":
                return (
                    <PhoneBookReadModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                    />
                );
            case "unify":
                return (
                    <PhoneBookUnifyModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        sprintf={this.sprintf}
                        propSetState = {(newState) => {
                            if (newState.show === false) {
                                // Cancel ボタンクリック時に元のモーダルに戻る
                                this.setState({
                                    modalType: this.state.previous_modal_type,
                                    show: true,
                                    previous_modal_type: null
                                });
                            } else {
                                this.setState(newState);
                            }
                        }}
                    />
                );
            case "import":
                return (
                    <PhoneBookImportModal
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        onImportComplete={this.onImportComplete}
                        currentPermission={this.props.currentPermission}
                    />
                );
            case "export":
                return (
                    <PhoneBookExportModal
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                    />
                );
            default:
                return null;
        }
    }

    /**
     * ★追加: ダブルモーダル用 - 音声再生モーダル描画 (#142)
     * playbackModal=true の時に summary モーダルの上に重ねて表示する
     */
    getPlaybackModal() {
        if (!this.state.playbackModal) {
            return null;
        }

        // RecordPlaybackModal用にstateをマッピング
        const playbackState = {
            ...this.state,
            show: true, // playbackModalがtrueの場合は常に表示
            modalType: 'playback', // ★追加: AscModalが正しいボタンを表示するために必要
            id: this.state.id, // ★追加: 削除時に必要なht60_idを設定
            url: this.state.playback_url,
            external_number: this.state.playback_external_number,
            dest_tel_number: this.state.playback_dest_tel_number,
            inout_type: this.state.playback_inout_type,
            answer_datetime: this.state.playback_answer_datetime,
            ht87_voice_log_to_text: this.state.playback_ht87_voice_log_to_text,
            ht88_categories: this.state.playback_ht88_categories,
            ht88_analysis_data: this.state.playback_ht88_analysis_data,
            s3_object_key: this.state.playback_s3_object_key,
            customer_id: this.state.playback_customer_id,
            customer_name: this.state.playback_customer_name,
            memo: this.state.playback_memo // 電話帳メモの混入を防ぐため録音メモで上書き
        };

        return (
            <RecordPlaybackModal
                state={playbackState}
                reactTableRefresh={async () => {
                    // ★録音削除後の処理: 通話履歴内の削除フラグを更新してモーダルを閉じる (#142)
                    const now = new Date();
                    const deletedUserId = this.props.userInfo.user_id;
                    
                    // ★修正: 削除対象の通話履歴を特定するため、playback_で始まる情報を使用 (#142)
                    const deletedAnswerDatetime = this.state.playback_answer_datetime;
                    const deletedDestTelNumber = this.state.playback_dest_tel_number;
                    const deletedInoutType = this.state.playback_inout_type;
                    
                    // ★追加: 削除フラグを永続化用stateに保存 (#142)
                    const awt012Id = this.state.selectedData[0] && this.state.selectedData[0].id;
                    const flagKey = `${deletedAnswerDatetime}_${deletedDestTelNumber}_${deletedInoutType}`;
                    const newDeletedVoiceFlags = {
                        ...this.state.deletedVoiceFlags,
                        [awt012Id]: {
                            ...(this.state.deletedVoiceFlags[awt012Id] || {}),
                            [flagKey]: {
                                voice_del_flag: 'Y',
                                voice_deleted: now,
                                voice_deleted_user_id: deletedUserId
                            }
                        }
                    };
                    
                    // selectedDataの通話履歴を更新（削除フラグを立てる）
                    if (this.state.selectedData && this.state.selectedData.length > 0) {
                        const updatedSelectedData = [...this.state.selectedData];
                        if (updatedSelectedData[0].call_histories) {
                            updatedSelectedData[0].call_histories = updatedSelectedData[0].call_histories.map(history => {
                                // ★修正: answer_datetime, dest_tel_number, inout_typeで照合 (#142)
                                if (history.answer_datetime === deletedAnswerDatetime &&
                                    history.dest_tel_number === deletedDestTelNumber &&
                                    history.inout_type === deletedInoutType) {
                                    return {
                                        ...history,
                                        voice_del_flag: 'Y',
                                        voice_deleted: now,
                                        voice_deleted_user_id: deletedUserId
                                    };
                                }
                                return history;
                            });
                        }
                        
                        // ★修正: 再生モーダルだけを閉じて、要約詳細情報モーダルは開いたまま (#142)
                        await this.setState({
                            selectedData: updatedSelectedData,
                            deletedVoiceFlags: newDeletedVoiceFlags,
                            playbackModal: false
                            // show: false は削除 → 要約詳細情報モーダルを閉じない
                        });
                    } else {
                        await this.setState({ 
                            deletedVoiceFlags: newDeletedVoiceFlags,
                            playbackModal: false
                            // show: false は削除 → 要約詳細情報モーダルを閉じない
                        });
                    }
                    
                    // ★修正: テーブル更新を削除 → ページ位置を保持 (#142)
                    // await this.reactTableRefresh();
                }}
                propSetState={(newState) => {
                    // playbackモーダルを閉じる場合の処理
                    if (newState.show === false) {
                        this.setState({ playbackModal: false });
                    } else {
                        // memoが更新された場合はplayback_memoのみに反映し、
                        // 電話帳のmemo（this.state.memo）は変更しない
                        if (newState.memo !== undefined) {
                            const { memo, ...restState } = newState;
                            this.setState({ ...restState, playback_memo: memo });
                        } else {
                            this.setState(newState);
                        }
                    }
                }}
                langText={this.props.langText}
                charaLimit={this.props.charaLimit}
                boardWidth={this.props.boardWidth}
                showErrorObjectMessage={this.showErrorObjectMessage}
                options={this.props.userInfo.options}
                currentPermission={this.props.currentPermission}
                // 【#549】この画面の currentPermission は permission_data.PhoneBook である。
                // メモの保存はサーバーが permission_data.Record.update を見るため、
                // Record 権限を別 props で渡す。PhoneBook.update と食い違っても判定がずれない。
                recordPermission={this.props.userInfo.permission_data
                    && this.props.userInfo.permission_data.Record}
                secToTime={this.secToTime}
                downloadCallContents={this.downloadCallContents}
                ascAxios={this.ascAxios}
            />
        );
    }

    /**
     * 外線番号重複チェック
     */
    checkDuplicateExternalNumber = async (externalNumbers, excludeId = null) => {
        try {
            if (!externalNumbers || externalNumbers.length === 0) {
                return null;
            }

            const external_numbers = externalNumbers.map(item => item.value);
            const requestBody = {
                external_numbers: external_numbers
            };
            
            // 編集時は自分自身のIDを除外するパラメータを追加
            if (excludeId) {
                requestBody.exclude_id = excludeId;
            }
            
            const response = await this.ascAxios('post', 'PhoneBook/duplicateCheck', requestBody);

            // APIレスポンスの確認と処理
            if (response.data) {
                // レスポンスが配列の場合（実際のAPI形式）
                if (Array.isArray(response.data)) {
                    if (response.data.length > 0) {
                        // 複数の重複エントリがある場合も考慮
                        return response.data; // 全ての重複データを返す
                    } else {
                        return null;
                    }
                }
                // レスポンスがオブジェクトの場合（従来形式への後方互換性）
                else if (typeof response.data === 'object') {
                    // awt010_dest_tel_numbers がある場合（単一オブジェクト形式）
                    if (response.data.awt010_dest_tel_numbers || response.data.awt012_name) {
                        return [response.data]; // 配列形式に統一
                    }
                    // 従来の形式
                    else if (response.data.dest_tel_number || response.data.duplicate_found) {
                        return response.data;
                    } else {
                        return null;
                    }
                }
                // その他の形式
                else {
                    return null;
                }
            } else {
                return null;
            }
        } catch (err) {
            console.error(err);
            // API呼び出しエラーの場合は重複なしとして処理を続行
            if (err.response) {
                console.error(err.response.data);
                console.error(err.response.status);
            } else if (err.request) {
                console.error(err.request);
            } else {
                console.error(err.message);
            }
            return null;
        }
    }

    /**
     * 重複チェック及びUnifyModal表示処理
     */
    handleDuplicateCheck = async (externalNumber, modalType, excludeId = null) => {
        const duplicateData = await this.checkDuplicateExternalNumber(externalNumber, excludeId);
        
        if (duplicateData) {
            let filteredDuplicateData = duplicateData;
            
            // フロントエンド側で自分自身のIDを除外（バックエンドが対応していない場合の対策）
            if (excludeId && Array.isArray(duplicateData)) {
                filteredDuplicateData = duplicateData.filter(item => {
                    // awt012_idまたはidが自分自身のIDと異なるもののみを残す
                    const itemId = item.awt012_id || item.id;
                    return itemId !== excludeId;
                });
            } else if (excludeId && typeof duplicateData === 'object') {
                // 単一オブジェクトの場合
                const itemId = duplicateData.awt012_id || duplicateData.id;
                if (itemId === excludeId) {
                    // 自分自身の場合は重複なしとして処理
                    return false;
                }
                filteredDuplicateData = duplicateData;
            }
            
            // フィルタ後にデータが残っているかチェック
            if (!filteredDuplicateData || 
                (Array.isArray(filteredDuplicateData) && filteredDuplicateData.length === 0)) {
                return false; // 重複なし
            }
            
            // 複数の重複データを処理
            const duplicateDataArray = Array.isArray(filteredDuplicateData) ? filteredDuplicateData : [filteredDuplicateData];
            
            // すべての重複番号を収集
            const allDuplicateNumbers = [];
            const inputNumbers = externalNumber.map(item => item.value);
            
            duplicateDataArray.forEach(duplicateItem => {
                if (duplicateItem.awt010_dest_tel_numbers && Array.isArray(duplicateItem.awt010_dest_tel_numbers)) {
                    const existingNumbers = duplicateItem.awt010_dest_tel_numbers.map(item => item.dest_tel_number);
                    // 入力された番号の中で重複しているものを探す
                    const foundDuplicates = inputNumbers.filter(inputNum => existingNumbers.includes(inputNum));
                    allDuplicateNumbers.push(...foundDuplicates);
                }
            });
            
            // 重複番号の重複を除去
            const uniqueDuplicateNumbers = [...new Set(allDuplicateNumbers)];
            
            // 最初の重複エントリを使用（表示用）
            const firstDuplicate = duplicateDataArray[0];
            
            // 会社名を取得（複数ある場合は最初のもの、または統合メッセージ用）
            let companyName = firstDuplicate.awt012_name || this.props.langText.Body.UnknownCompany;
            if (duplicateDataArray.length > 1) {
                // 複数の会社がある場合は複数会社であることを示す
                const companyNames = duplicateDataArray.map(item => item.awt012_name).filter(name => name);
                companyName = companyNames.join(', ') || this.props.langText.Body.UnknownCompany;
            }
            
            // すべての既存番号を統合
            const allExistingNumbers = [];
            duplicateDataArray.forEach(duplicateItem => {
                if (duplicateItem.awt010_dest_tel_numbers && Array.isArray(duplicateItem.awt010_dest_tel_numbers)) {
                    const existingNumbers = duplicateItem.awt010_dest_tel_numbers.map(item => ({
                        value: item.dest_tel_number
                    }));
                    allExistingNumbers.push(...existingNumbers);
                }
            });
            
            this.setState({
                duplicate_phonebook_external_numbers: uniqueDuplicateNumbers, // 複数の重複番号を配列で保存
                duplicate_phonebook_external_number: uniqueDuplicateNumbers[0] || '', // 後方互換性のため
                company_name: companyName,
                existing_external_number: allExistingNumbers,
                existing_phonebook_id: firstDuplicate.awt012_id, // 既存要約詳細のID保存
                duplicate_data_list: duplicateDataArray, // 全重複データを保存
                modalType: "unify",
                show: true,
                previous_modal_type: modalType
            });
            
            return true; // 重複が見つかった
        }
        
        return false; // 重複なし
    };

    /**
     * external_numberをdest_tel_list形式に変換
     */
    convertToDestTelList = (externalNumber, type = "not_join") => {
        return externalNumber.map(item => ({
            type: type, // 重複がないのでnot_joinに設定
            dest_tel_number: item.value
        }));
    };

    /**
     * PhoneBook API呼び出し実行
     */
    executePhoneBookOperation = async (operation, params, successMessage, silent = false) => {
        this.blockUI();
        
        await this.ascAxios('post', `${this.reactContainerPath}/${operation}`, params);
        
        if (!silent && successMessage) {
            alert(successMessage);
        }
        
        if (!silent) {
            this.reactTableRefresh(true);
        }
    };

    onMultiSelectChange_External = async (event) => {
        const selectedValues = Array.isArray(event) ? event : [];
        const values = extractExternalValues(selectedValues);
        const invalids = detectInvalidExternalNumbers(selectedValues);
        this.setState({
            external_number: selectedValues,
            external_number_val: values,
            external_number_invalids: invalids
        });
    }

    /**
     * モーダル表示
     */
    modalShow = (modalType) => async event => {
        event.preventDefault();
        
        // ★修正: 削除フラグマージ後のデータを新しい変数に保持して確実に反映 (#142)
        let { selectedData } = this.state;
        let mergedSelectedData = selectedData ? JSON.parse(JSON.stringify(selectedData)) : [];
        
        let rowInfo = '';
        // ひとつだけ選択して編集または閲覧ボタンを押した場合
        if (modalType === "update" || modalType === "read" || (modalType === "delete" && mergedSelectedData.length === 1)) {
            rowInfo = mergedSelectedData.slice().pop();
        } 
        // 編集・削除の場合一つ以上の項目選択必須
        if((modalType === "update" || modalType === "read" || modalType === "delete" ) && mergedSelectedData.length === 0){
            return this.showErrorObjectMessage('ModalSelectError');
        }
        // 編集場合一つの項目だけ選択可能
        if((modalType === "update" || modalType === "read") && mergedSelectedData.length > 1){
            return this.showErrorObjectMessage('UpdateModalSelectError');
        }

        let setData = {
            id: rowInfo && rowInfo.id
                ? rowInfo.id
                : 0,
            name: rowInfo && rowInfo.name
                ? rowInfo.name
                : "",
            phone_number: rowInfo && rowInfo.phone_number
                ? rowInfo.phone_number
                : "",
            memo: rowInfo && rowInfo.memo
                ? rowInfo.memo
                : "",
            last_call: rowInfo && rowInfo.last_call
                ? rowInfo.last_call
                : "",
            category: rowInfo && rowInfo.category
                ? rowInfo.category
                : "",
            call_histories_total_count: rowInfo && rowInfo.call_histories_total_count
                ? rowInfo.call_histories_total_count
            : "",
            external_number: [],
            external_number_val: [],
            external_number_invalids: [],
            modalType: modalType,
            show: true,
            // ★修正: マージ済みのデータを確実に反映 (#142)
            selectedData: mergedSelectedData
        }

        // awt010_dest_tel_numberからexternal_number形式に変換
        if (rowInfo && rowInfo.awt010_dest_tel_number && Array.isArray(rowInfo.awt010_dest_tel_number)) {
            const externalNumbers = rowInfo.awt010_dest_tel_number.map(item => ({
                value: item.dest_tel_number,
                label: item.dest_tel_number
            }));
            setData.external_number = externalNumbers;
            const { values, invalids } = evaluateExternalNumbers(externalNumbers);
            setData.external_number_val = values;
            setData.external_number_invalids = invalids;
        }

        if(modalType === "delete"){
            setData.id = mergedSelectedData.map(row=>row.id);
            setData.name = mergedSelectedData.map(row=>row.name);
        }

        // ★追加: read/updateモーダル表示時は先に通話履歴を全件取得 (#200)
        if ((modalType === "read" || modalType === "update") && mergedSelectedData && mergedSelectedData.length > 0 && mergedSelectedData[0].id) {
            // ★新アプローチ: 全件取得完了後にモーダルを開く
            // これによりデータ参照の変更を完全に回避
            const targetId = mergedSelectedData[0].id;
            
            // ローディング状態を先に設定（モーダルはまだ開かない）
            this.setState({ loadingCallHistories: true, show: false });
            
            (async () => {
                try {
                    // 全件取得APIを呼び出し
                    const fullDataResponse = await this.ascAxios('post', '/PhoneBook/fullCallHistories', {
                        id: targetId
                    });
                    
                    if (fullDataResponse && fullDataResponse.data) {
                        let fullCallHistories = fullDataResponse.data.call_histories || [];
                        const fullCallHistoriesTotalCount = fullDataResponse.data.call_histories_total_count || 0;
                        
                        // ★改善: サーバー側で削除フラグも含めて取得済み (#200 - パフォーマンス改善)
                        
                        // メモリ内の削除フラグもマージ
                        const savedFlags = this.state.deletedVoiceFlags[targetId];
                        
                        if (savedFlags) {
                            fullCallHistories = fullCallHistories.map(history => {
                                const flagKey = `${history.answer_datetime}_${history.dest_tel_number}_${history.inout_type}`;
                                const flagData = savedFlags[flagKey];
                                
                                if (flagData) {
                                    return {
                                        ...history,
                                        voice_del_flag: flagData.voice_del_flag,
                                        voice_deleted: flagData.voice_deleted,
                                        voice_deleted_user_id: flagData.voice_deleted_user_id
                                    };
                                }
                                return history;
                            });
                        }
                        
                        // 全件データでmergedSelectedDataを更新
                        mergedSelectedData[0].call_histories = fullCallHistories;
                        mergedSelectedData[0].call_histories_total_count = fullCallHistoriesTotalCount;
                        
                        // ★全件データで一度だけsetState（これでモーダル表示）
                        setData.selectedData = mergedSelectedData;
                        setData.call_histories_total_count = fullCallHistoriesTotalCount;
                        setData.loadingCallHistories = false;
                        this.setState(setData);
                    } else {
                        // データ取得失敗時は5件データでモーダル表示
                        setData.loadingCallHistories = false;
                        this.setState(setData);
                    }
                } catch (error) {
                    console.error('全件取得エラー:', error);
                    // エラー時は5件データでモーダル表示
                    setData.loadingCallHistories = false;
                    this.setState(setData);
                }
            })();
        } else {
            // read/update以外は通常通り表示
            this.setState(setData);
        }
    };

    /**
     * ★追加: 通話内容ダウンロード関数 (#142)
     * RecordPlaybackModalで使用される
     */
    downloadCallContents = async (rowData) => {
        try {
            let voiceLogToText = await this.ascAxios('post', `Record/getVoiceLogToTextByHt60id`, {ht60_id: rowData.id});
            let content = "";

            // 通話分類
            if (rowData.ht88_categories && rowData.ht88_categories.length > 0) {
                content += `【${this.props.langText.Body.CallCategory}】\n`;
                for (let i = 0; i < rowData.ht88_categories.length; i++) {
                    content += rowData.ht88_categories[i].name;
                    if (i < rowData.ht88_categories.length - 1) {
                        content += "、";
                    } else {
                        content += "\n\n";
                    }
                }
            }

            // 通話概要
            if (rowData.ht88_analysis_data) {
                content += `【${this.props.langText.Body.CallAnalysisData}】\n`;
                content += rowData.ht88_analysis_data + "\n\n";
            }

            // AI録音文字起こし
            if (voiceLogToText && voiceLogToText.data && voiceLogToText.data.ht87_voice_log_to_text) {
                let ht87_voice_log_to_text = voiceLogToText.data.ht87_voice_log_to_text;
                content += `【${this.props.langText.Body.audio2text}】\n`;
                for (let i = 0; i < ht87_voice_log_to_text.text_data_json.length; i++) {
                    let inout_type = ht87_voice_log_to_text.text_data_json[i].inout === "in" 
                        ? this.props.langText.Body.Client : this.props.langText.Body.User;
                    content += this.secToTime(Math.floor(ht87_voice_log_to_text.text_data_json[i].start)) 
                    + ` (${inout_type}) ` + ht87_voice_log_to_text.text_data_json[i].text + "\n\n";
                }
            }

            // テキストファイルをダウンロード
            const blob = new Blob([content], { type: CALL_TEXT_DOWNLOAD.MIME_TYPE });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", buildCallTextDownloadFilenameFromPlaybackState(rowData));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('downloadCallContents エラー:', e);
            this.showErrorObjectMessage(e);
        }
    }

    /**
     * ★追加: 音声再生処理 (#142 - レビュー対応: request_id優先)
     * 通話履歴から音声を再生する
     */
    onPlayAudio = async (callHistoryData) => {
        // ★修正: エラーハンドリングを改善してエラー時は早期リターン (#142)
        try {
            // ★重要: 再生モーダルの「外線番号」は通話履歴（録音）側の外線番号を表示する
            // PhoneBookの awt010_dest_tel_number は要約詳細の電話番号（相手先番号）であり、ここから取ると
            // 外線番号欄にも相手先番号が入ってしまう。
            let externalNumber = (callHistoryData && (
                callHistoryData.external_number ||
                callHistoryData.externalNumber ||
                callHistoryData.external_tel_number ||
                callHistoryData.externalTelNumber
            )) || "";
            
            // 通話履歴情報からht60_idと削除情報を取得
            let ht60Id = null;
            let ht60S3ObjectKey = null;
            let voiceDelFlag = null;
            let voiceDeleted = null;
            let voiceDeletedUserId = null;
            
            // ★レビュー対応: request_idがある場合のみ検索
            if (!callHistoryData.request_id) {
                alert(this.props.langText.Message.PhoneBook_PlaybackIdentifierMissing);
                return;
            }
            
            try {
                const ht60Res = await this.ascAxios('post', 'PhoneBook/getHt60IdByRequestId', {
                    request_id: callHistoryData.request_id
                });
                
                ht60Id = ht60Res.data.ht60_id;
                ht60S3ObjectKey = ht60Res.data.s3_object_key;
                voiceDelFlag = ht60Res.data.voice_del_flag;
                voiceDeleted = ht60Res.data.voice_deleted;
                voiceDeletedUserId = ht60Res.data.voice_deleted_user_id;

                // ★補完: Anywhere側の通話履歴に外線番号が無いケースがあるため、ht60側の値でフォールバック
                if (!externalNumber && ht60Res.data && ht60Res.data.external_number) {
                    externalNumber = ht60Res.data.external_number;
                }
            } catch (searchError) {
                console.error('ht60_id取得エラー:', searchError);
                alert(this.props.langText.Message.PhoneBook_PlaybackRecordNotFound);
                return;
            }
            
            // S3のpresigned URLを取得
            const urlRes = await this.ascAxios('post', 'Record/getS3PreSignedUrl', {
                id: ht60Id
            });
            
            // ★修正: 文字起こしデータを取得（API形式を修正）(#142)
            let textData = null;
            try {
                const textRes = await this.ascAxios('post', 'Record/getVoiceLogToTextByHt60id', {
                    ht60_id: ht60Id
                });
                textData = textRes.data; // ★修正: textRes.dataに文字起こしデータが入っている (#142)
            } catch (e) {
                console.warn('文字起こしデータの取得に失敗:', e);
            }
            
            // ★修正: 音声再生モーダルを表示(文字起こしデータの設定を修正)(#142)
            // PhoneBookのデータ構造: awt018_categories は配列、analysis_data_overview が通話概要
            const categories = callHistoryData.awt062_call_history_detail 
                && callHistoryData.awt062_call_history_detail.awt018_categories
                ? callHistoryData.awt062_call_history_detail.awt018_categories // ★修正: 既に配列なのでそのまま使用
                : [];
            
            const analysisData = callHistoryData.awt062_call_history_detail
                && callHistoryData.awt062_call_history_detail.analysis_data
                ? callHistoryData.awt062_call_history_detail.analysis_data
                : "";

            // 録音に紐づくメモを取得
            let recordMemo = "";
            try {
                const memoRes = await this.ascAxios('post', 'Record/getMemo', {
                    ht60_id: ht60Id
                });
                recordMemo = memoRes && memoRes.data ? memoRes.data.memo : "";
            } catch (e) {
                console.warn('録音メモの取得に失敗:', e);
            }
            
            this.setState({
                id: ht60Id,
                voice_del_flag: voiceDelFlag,
                voice_deleted: voiceDeleted,
                voice_deleted_user_id: voiceDeletedUserId,
                playback_external_number: externalNumber, // ★修正: 通話履歴(callHistoryData)側の外線番号を使用
                playback_dest_tel_number: callHistoryData.dest_tel_number || "",
                playback_inout_type: callHistoryData.inout_type || "",
                playback_answer_datetime: callHistoryData.answer_datetime || "",
                playback_customer_id: callHistoryData.hm01_customer_info 
                    ? callHistoryData.hm01_customer_info.id : "",
                playback_customer_name: callHistoryData.hm01_customer_info 
                    ? callHistoryData.hm01_customer_info.name : "",
                playback_url: urlRes.data,
                playback_ht87_voice_log_to_text: textData && textData.ht87_voice_log_to_text
                    ? textData.ht87_voice_log_to_text : "",
                playback_ht88_categories: categories, // ★修正: 配列形式に変換
                playback_ht88_analysis_data: analysisData, // ★修正: analysis_data_overview を使用
                // ★修正: PhoneBook側の通話履歴データのs3_object_keyがダミーの場合があるため、ht60側のs3_object_keyを優先
                playback_s3_object_key: (ht60S3ObjectKey
                    ? ht60S3ObjectKey.split("/").pop()
                    : (callHistoryData.s3_object_key ? callHistoryData.s3_object_key.split("/").pop() : "")),
                playback_memo: recordMemo, // 録音に紐づくメモ
                // ★修正: ダブルモーダル対応 - modalTypeはsummaryのまま維持、playbackModalをtrueにする
                playbackModal: true
            });
        } catch (e) {
            console.error('onPlayAudio エラー:', e);
            alert(this.props.langText.Message.PhoneBook_PlaybackPrepareError);
        }
    }

    /**
     * 各画面先でのボタン押下時の動作内容
     */
    onClickHandle = modalType => async () => {
        let shouldCloseModal = true; // モーダルを閉じるかどうかを決定するフラグ
        
        try {
            switch (modalType) {
                case 'insert':
                    // 最新のstate値を取得
                    const {
                        name: insertName,
                        memo: insertMemo,
                        external_number: insertExternalNumber
                    } = this.state;
                    
                    // 登録前に重複チェックを実行
                    const hasDuplicate = await this.handleDuplicateCheck(insertExternalNumber, "insert");
                    
                    if (hasDuplicate) {
                        shouldCloseModal = false; // モーダルを閉じない
                        return;
                    }
                    
                    // 重複がないときにPhoneBook操作実行
                    const dest_tel_list = this.convertToDestTelList(insertExternalNumber);
                    
                    await this.executePhoneBookOperation('insert', {
                        phone_book_name: insertName,
                        memo: insertMemo,
                        dest_tel_list: dest_tel_list
                    }, this.props.langText.Message.DataInsertSuccess);
                    break;
                case 'update':
                    // 最新のstate値を取得
                    const {
                        id: updateId,
                        name: updateName,
                        memo: updateMemo,
                        external_number: updateExternalNumber
                    } = this.state;
                    
                    // 更新前に重複チェックを実行
                    const updateHasDuplicate = await this.handleDuplicateCheck(updateExternalNumber, "update", updateId);
                    
                    if (updateHasDuplicate) {
                        shouldCloseModal = false; // モーダルを閉じない
                        return;
                    }
                    
                    // 重複がないときにPhoneBook操作実行
                    const update_dest_tel_list = this.convertToDestTelList(updateExternalNumber);
                    
                    await this.executePhoneBookOperation('update', {
                        id: updateId,
                        phone_book_name: updateName,
                        memo: updateMemo,
                        dest_tel_list: update_dest_tel_list
                    }, this.props.langText.Message.DataUpdateSuccess);
                    break;
                case 'delete':
                    this.blockUI();
                    await this.executePhoneBookOperation('delete', {
                        id: this.state.id
                    }, this.props.langText.Message.DataDeleteSuccess);
                    break;
                case 'unify':
                    // 結合処理: 既存要約詳細を削除してすべての外線番号を新規要約詳細に移転
                    this.blockUI();
                    
                    const {
                        name: unifyName,
                        memo: unifyMemo,
                        external_number: unifyExternalNumber,
                        existing_external_number: existingNumbers,
                        company_name: existingCompanyName,
                        duplicate_data_list: duplicateDataList
                    } = this.state;
                    
                    try {
                        
                        // 1. すべての既存要約詳細を削除
                        if (duplicateDataList && Array.isArray(duplicateDataList) && duplicateDataList.length > 0) {
                            // 複数の重複データがある場合、すべて削除
                            for (const duplicateItem of duplicateDataList) {
                                if (duplicateItem.awt012_id) {
                                    await this.executePhoneBookOperation('delete', {
                                        id: duplicateItem.awt012_id
                                    }, null, true); // サイレントモードで削除
                                }
                            }
                        } else if (this.state.existing_phonebook_id) {
                            // 従来の単一削除（後方互換性）
                            await this.executePhoneBookOperation('delete', {
                                id: this.state.existing_phonebook_id
                            }, null, true); // サイレントモードで削除
                        }
                        
                        // 2. すべての外線番号統合 (既存 + 新規)
                        const allExternalNumbers = [...unifyExternalNumber];
                        
                        // 既存番号から重複を除去してから処理
                        if (existingNumbers && Array.isArray(existingNumbers)) {
                            // 既存番号の重複を除去
                            const uniqueExistingNumbers = [];
                            const seenNumbers = new Set();
                            
                            existingNumbers.forEach(existingNum => {
                                if (!seenNumbers.has(existingNum.value)) {
                                    seenNumbers.add(existingNum.value);
                                    uniqueExistingNumbers.push(existingNum);
                                }
                            });
                            
                            // 新規番号のリストを取得
                            const newNumbers = unifyExternalNumber.map(item => item.value);
                            
                            // 重複除去済みの既存番号の中で新規番号と重複しないもののみ追加
                            uniqueExistingNumbers.forEach(existingNum => {
                                if (!newNumbers.includes(existingNum.value)) {
                                    allExternalNumbers.push({
                                        value: existingNum.value,
                                        label: existingNum.value
                                    });
                                }
                            });
                        }
                        
                        // 最終的な重複チェック（念のため）
                        const finalUniqueNumbers = [];
                        const finalSeenNumbers = new Set();
                        
                        allExternalNumbers.forEach(item => {
                            if (!finalSeenNumbers.has(item.value)) {
                                finalSeenNumbers.add(item.value);
                                finalUniqueNumbers.push(item);
                            }
                        });
                        
                        // 3. dest_tel_list形式に変換
                        const unified_dest_tel_list = finalUniqueNumbers.map(item => ({
                            type: "unified", // 統合された番号であることを表示
                            dest_tel_number: item.value
                        }));
                        
                        // 4. 成功メッセージの準備
                        let successMessage = '';
                        
                        // 重複データの数を正確に判定
                        const duplicateCount = (duplicateDataList && Array.isArray(duplicateDataList)) ? duplicateDataList.length : 0;
                        
                        if (duplicateCount > 1) {
                            // 複数の会社がある場合
                            const companyNames = duplicateDataList.map(item => `"${item.awt012_name || 'Unknown'}"`).join(', ');
                            if (this.state.previous_modal_type === 'insert') {
                                successMessage = this.sprintf(this.props.langText.Message.UnifyCompleteMultipleInsert, companyNames, unifyName);
                            } else if (this.state.previous_modal_type === 'update') {
                                successMessage = this.sprintf(this.props.langText.Message.UnifyCompleteMultipleUpdate, companyNames, unifyName);
                            }
                        } else if (duplicateCount === 1) {
                            // 単一の会社の場合
                            const singleCompanyName = (duplicateDataList[0] && duplicateDataList[0].awt012_name) || existingCompanyName || 'Unknown';
                            if (this.state.previous_modal_type === 'insert') {
                                successMessage = this.sprintf(this.props.langText.Message.UnifyCompleteSingleInsert, singleCompanyName, unifyName);
                            } else if (this.state.previous_modal_type === 'update') {
                                successMessage = this.sprintf(this.props.langText.Message.UnifyCompleteSingleUpdate, singleCompanyName, unifyName);
                            }
                        } else {
                            // フォールバック（重複データがない場合 - 通常は発生しない）
                            if (this.state.previous_modal_type === 'insert') {
                                successMessage = this.sprintf(this.props.langText.Message.UnifyFallbackInsert, unifyName);
                            } else if (this.state.previous_modal_type === 'update') {
                                successMessage = this.sprintf(this.props.langText.Message.UnifyFallbackUpdate, unifyName);
                            }
                        }
                        
                        // 5. 新しい要約詳細として登録
                        if (this.state.previous_modal_type === 'insert') {
                            await this.executePhoneBookOperation('insert', {
                                phone_book_name: unifyName,
                                memo: unifyMemo,
                                dest_tel_list: unified_dest_tel_list
                            }, successMessage);
                        } else if (this.state.previous_modal_type === 'update') {
                            await this.executePhoneBookOperation('update', {
                                id: this.state.id,
                                phone_book_name: unifyName,
                                memo: unifyMemo,
                                dest_tel_list: unified_dest_tel_list
                            }, successMessage);
                        }
                        
                    } catch (deleteError) {
                        console.error(deleteError);
                        alert(this.props.langText.Message.UnifyProcessError);
                        this.unblockUI();
                        return;
                    }
                    
                    this.reactTableRefresh(true);
                    break;
                case 'unify_cancel':
                    // キャンセル: 元のモーダルに戻る
                    shouldCloseModal = false; // モーダルを閉じない
                    this.setState({
                        modalType: this.state.previous_modal_type,
                        show: true,
                        previous_modal_type: null
                    });
                    return;
                default:
                    this.showErrorObjectMessage('ModalTypeError');
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            // 重複が発見された場合以外はモーダルを閉じる
            if (shouldCloseModal) {
                this.setState({show: false});
            }
        }
    };

    /**
     * 各画面のボタン押下条件
     */
    validationHandle = (param) => {
        let validation_flag = false;
        let {
            id,
            name,
            external_number_val
        } = this.state;

        // 状態 external_number_invalids に依存せず、その場で再計算してレース条件を排除
        // 入力タグ配列 this.state.external_number から最新値を評価
        const { invalids: recomputedInvalids } = evaluateExternalNumbers(
            Array.isArray(this.state.external_number) ? this.state.external_number : []
        );

        switch (param) {
            case "insert":
                // 名前 + 外線番号必須 + 全件バリデーション通過（再計算結果使用）
                validation_flag = !!(name && external_number_val && external_number_val.length > 0 && recomputedInvalids.length === 0);
                break;
            case "update":
                // 名前 + 外線番号必須 + 全件バリデーション通過（再計算結果使用）
                validation_flag = !!(name && external_number_val && external_number_val.length > 0 && recomputedInvalids.length === 0);
                break;
            case "delete":  
                validation_flag = !!(id);
                break;
            case "read":
                validation_flag = !!(id);
                break;
            case "unify":
                validation_flag = true; // 結合ボタンを有効化
                break;
            case "unify_proceed":
                validation_flag = true; // 統合続行も常に有効
                break;
            default:
                break;
        }
        
        return validation_flag;
    };

    render() {
        return (
            <div className="PhoneBook">
                {/*一覧画面*/}
                <Row>
<Col xs={12} md={12}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
            <Button
                id = "phonebook-insert"
                className = "table-button"
                variant = "default"
                size = "sm"
                onClick={this.modalShow("insert")}
                hidden={!this.props.currentPermission.create}
                disabled={this.state.selectedData.length >= 1}
            >
                {this.props.langText.Body.InsertTitle}
            </Button>
            <Button
                id = "phonebook-update"
                className = "table-button"
                variant = "default"
                size = "sm"
                onClick={this.modalShow("update")}
                hidden={!this.props.currentPermission.update}
                disabled={!(this.state.selectedData.length === 1)}
            >
                {this.props.langText.Body.UpdateTitle}
            </Button>
            <Button
                id = 'phonebook-read'
                className = 'table-button'
                variant = 'default'
                size = 'sm'
                onClick={this.modalShow('read')}
                hidden={!!this.props.currentPermission.update}
                disabled={!(this.state.selectedData.length === 1)}
            >
                {this.props.langText.Body.ReadTitle}
            </Button>
            <Button
                id = "phonebook-delete"
                className = "table-button"
                variant = "default"
                size = "sm"
                onClick={this.modalShow("delete")}
                hidden={!this.props.currentPermission.delete}
                disabled={this.state.selectedData.length === 0}
            >
                {this.props.langText.Body.DeleteTitle}
            </Button>
        </div>
        <div>
            {this.props.currentPermission.create && (
                <Button
                    id = "phonebook-import"
                    className = "table-button"
                    variant = "default"
                    size = "sm"
                    onClick={this.modalShow("import")}
                >
                    {this.props.langText.Body.PhoneBookImport}
                </Button>
            )}
            {this.props.currentPermission.download && (
                <Button
                    id = "phonebook-export"
                    className = "table-button"
                    variant = "default"
                    size = "sm"
                    onClick={this.modalShow("export")}
                >
                    {this.props.langText.Body.PhoneBookExport}
                </Button>
            )}
        </div>
    </div>
</Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            ref={this.tableRef}
                            showPageSize={true}
                            showCheckbox={true}
                            showPagination={true}
                            showFilter={true}
                            propsPageIndex = {this.state.pageIndex? this.state.pageIndex: 0}
                            state = {this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={this.props.tableHeight-30}
                            columns={this.state.columns}
                            data={this.state.data}
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount = {this.state.pageCount}
                            manual = {true}
                            langText = {this.props.langText.Table}
                            className="phonebook-table"
                            onSelectedDataChange={(selected) => {
                                try {
                                    // ★修正: 永続化された削除フラグをマージ (#142)
                                    if (selected && selected.length > 0 && selected[0].call_histories) {
                                        const awt012Id = selected[0].id;
                                        const savedFlags = this.state.deletedVoiceFlags[awt012Id];
                                        
                                        if (savedFlags) {
                                            selected[0].call_histories = selected[0].call_histories.map(history => {
                                                const flagKey = `${history.answer_datetime}_${history.dest_tel_number}_${history.inout_type}`;
                                                const flagData = savedFlags[flagKey];
                                                
                                                if (flagData) {
                                                    return {
                                                        ...history,
                                                        voice_del_flag: flagData.voice_del_flag,
                                                        voice_deleted: flagData.voice_deleted,
                                                        voice_deleted_user_id: flagData.voice_deleted_user_id
                                                    };
                                                }
                                                return history;
                                            });
                                        }
                                    }
                                    
                                    this.setState({ selectedData: selected });
                                } catch (e) {
                                    console.error('selectedData更新エラー:', e);
                                }
                            }}
                        />
                    </Col>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
                {/*★追加: ダブルモーダル - 音声再生モーダル (#142)*/}
                {this.getPlaybackModal()}
            </div>
        );
    }
} 